import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { NxtbnDrawer } from "..";
import useApi from "../../api";

import AddCustomerPromo from "./addCustomerPromo";
import ApplicableCustomerTable from "./applicableCustomerTable";
import { StatusBar } from "../common";

const redemptionCountStatus = [
  { value: "0", label: "0+" },
  { value: "10", label: "10+" },
  { value: "50", label: "50+" },
  { value: "100", label: "100+" },
  { value: "500", label: "500+" },
  { value: "1000", label: "1000+" },
]


function ApplicableCustomer({ isOpen, onClose, code }: {isOpen: boolean; onClose: () => void; code: string | null}) {
  const [customers, setCustomers] = useState<any>({});
  const [addPromoProductModal, setAddPromoProductModal] = useState(false);
  const api = useApi();

  const fetchAttachedCustomers = () => {
    const params = {
        promo_code: code
    }
    api.getCustomerWithPromo(params).then((response) => {
        setCustomers(response)
    }, (error) => {
        toast.error("Failed to fetch promocode details")
    })
  }

  useEffect(() => {
    fetchAttachedCustomers();    
  }, [code]);

  return (
    <NxtbnDrawer title={`Applicable Customer of ${code}`} isOpen={isOpen} onClose={onClose}>
      <StatusBar
        onButtonClick={()=>setAddPromoProductModal(!addPromoProductModal)}
        statusList={redemptionCountStatus} 
        currentStatus={''} 
        onChangeStatus={() => {}} 
        buttonLabel="Attach Customer"
      />
       <ApplicableCustomerTable customers={customers.results || []} />

      <AddCustomerPromo onRefresh={fetchAttachedCustomers} isOpen={addPromoProductModal} onClose={() => setAddPromoProductModal(false)} code={code} />
    </NxtbnDrawer>
  );
}

export default ApplicableCustomer;
